import React from 'react';
import { ListChecks, Stethoscope } from 'lucide-react';
import { useTranslation } from '../i18n/I18nProvider.jsx';

// «خدمت» — what the next patient is coming FOR, on the day sheet's hero.
//
// One component for both heroes, because the SENTENCE is the same on a phone
// and on a reception monitor and only the type size differs. The two files
// already share StatusPill, PatientAvatar and the today.next.* vocabulary; a
// second copy of this composition is how the phone ends up saying something
// the desktop does not.
//
// `service` is `nextPlannedService()` — the first outstanding طرح درمان line —
// or null. Null is a real answer and is said in words: «ویزیت». It is NOT
// silence, because a blank where the treatment goes reads as "we do not know"
// on a screen whose whole job is a glance.
//
// The tooth rides along («ترمیم کامپوزیت · دندان ۱۶») because a dentist reads
// site and service as one fact, and «+۲» says the sitting has more waiting
// without promising a day's work in one appointment.

const NextServiceChip = ({ service, compact = false }) => {
  const { t, formatNumber } = useTranslation();

  const planned = !!service;
  // An untitled line is still a planned line — «ویزیت» here would claim the
  // patient has nothing outstanding, which is the opposite of the truth.
  const name = planned
    ? (service.label || t('visit.plan.untitledItem'))
    : t('today.next.serviceVisit');
  const Icon = planned ? ListChecks : Stethoscope;
  const size = compact ? 12 : 14;

  return (
    <div
      data-testid="today-next-service"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: compact ? 5 : 6,
        marginTop: 4,
        minWidth: 0,
        fontSize: compact ? '0.6875rem' : 13,
        fontWeight: 600,
        color: 'rgba(255,255,255,0.85)',
      }}
    >
      <Icon size={size} strokeWidth={2.4} aria-hidden style={{ flexShrink: 0 }} />
      <span
        dir="auto"
        style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
      >
        {t('today.next.service', { name })}
        {planned && service.toothFdi
          ? ` · ${t('visit.chart.tooth', { fdi: formatNumber(service.toothFdi) })}`
          : ''}
      </span>
      {planned && service.more > 0 && (
        <span
          style={{
            flexShrink: 0,
            fontSize: compact ? '0.625rem' : 11,
            fontWeight: 700,
            borderRadius: 20,
            padding: '1px 7px',
            background: 'rgba(255,255,255,0.22)',
          }}
        >
          {t('today.next.serviceMore', { count: service.more })}
        </span>
      )}
    </div>
  );
};

export default NextServiceChip;
